export default `
query categories(
	$pageSize: Int = 1
	$currentPage: Int = 1
	$filters: CategoryFilterInput
) {
	categories(
		pageSize: $pageSize
		currentPage: $currentPage
		filters: $filters
	) {
		items {
			children {
				uid
				image
				name
				include_in_menu
				products {
					items {
						name
						sku
            short_description {
              html
            }
						thumbnail {
							url
							position
							disabled
							label
						}
						hover_image {
							url
							position
							disabled
							label
						}
						analysis_type
						url_key
						url_rewrites {
							url
						}
            price_range {
              maximum_price {
                final_price {
                  currency
                  value
                }
                regular_price {
                  currency
                  value
                }
              }
              minimum_price {
                final_price {
                  currency
                  value
                }
                regular_price {
                  currency
                  value
                }
              }
            }
					}
				}
			}
		}
	}
}
`;
